import React from "react";
import "../About/About.css";
import WhyChoose from "../WhyChoose/WhyChoose";

import Strength from "./Strength";
import Security from "./Security";
import AboutCta from "./AboutCta";

const About = () => {
  return (
    <>
      {/* Hero Section */}
      <div className="hero-about">
        <div className="hero-overlay">
          <div className="hero-content-a">
            <div className="hero-badge">About Our Journey</div>
            <h1 className="hero-titlea">About Click4Flight</h1>
            <p className="hero-subtitle">
              Crafting unforgettable journeys with passion, expertise, and
              dedication to excellence
            </p>
            {/*--
            <div className="hero-stats">
              <div className="stat">
                <span className="stat-number">10+</span>
                <span className="stat-label">Years Experience</span>
              </div>
              <div className="stat">
                <span className="stat-number">5000+</span>
                <span className="stat-label">Happy Travelers</span>
              </div>
              <div className="stat">
                <span className="stat-number">50+</span>
                <span className="stat-label">Destinations</span>
              </div>
            </div>
            --*/}
          </div>
        </div>
      </div>

      {/* About Content Section */}
      <section className="about-content">
        <div className="content-container">
          <div className="about-50">
            {/* LEFT CONTENT */}
            <div className="about-left">
              <div className="section-headeraa">
                <h2 className="section-titleaa">
                  Global Reach. Specialist Expertise.
                </h2>

                <p className="section-introa">
                  Welcome to Click4Flight, your premier gateway to the world. We
                  are a leading travel agency specializing in Worldwide
                  Long-Haul travel, providing seamless flight solutions and
                  tailor- made holiday experiences across every continent. From
                  the bustling metropolises of Asia and the USA to the remote
                  landscapes of Australia, New Zealand, and the Indian Ocean, we
                  bring the world closer to you.
                </p>
              </div>
            </div>

            {/* RIGHT IMAGE */}
            <div className="about-right">
              <div className="about-img-con">
                <img src="/abb.webp" className="abt-img" alt="image-about" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="section-headera">
          <h2 className="section-titlea">Redefining Long-Haul Travel</h2>
          <div className="title-linea"></div>
          <p className="section-intro">
            At Click4Flight, we understand that long-distance travel requires
            more than just a ticket—it requires precision, comfort, and value.
            Our mission is to simplify the complexities of international travel
            by offering:
          </p>
        </div>
        <div className="features-container">
          <div className="feature-card">
            <div className="feature-icon">✈</div>
            <h3 className="feature-title">Unlimited Global Destinations</h3>
            <p className="feature-desc">
              Whether it’s a direct flight to New York, a multi-stop tour of
              South East Asia, or a luxury escape to the Maldives, we cover the
              entire globe.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">👨🏻‍💼</div>
            <h3 className="feature-title">Specialist Knowledge</h3>
            <p className="feature-desc">
              While we are worldwide experts, we have dedicated teams focusing
              on high-demand markets like the Caribbean, Australia, and North
              America, ensuring you get "insider" rates and routes.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">⭐</div>
            <h3 className="feature-title">Exclusive Private Fares</h3>
            <p className="feature-desc">
              We leverage industry relationships to access "Phone-Only" airfares
              that are not available on public search engines, saving you more
              on premium cabins and popular routes.
            </p>
          </div>
        </div>
      </section>
      <Strength />
      {/* Quote Section */}
      <div className="inspiration-section">
        <div className="inspiration-overlay"></div>
        <div className="inspiration-content">
          <div className="quote-icon">❝</div>
          <h2 className="quote-text">
            The world is a book, and those who do not travel read only one page
          </h2>
        </div>
      </div>
      <Security />

      <AboutCta />
      <WhyChoose />
    </>
  );
};

export default About;
